const INITIAL_STATE = {};

export default function myPerformance(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'fetchGraphData') {
        return {
          ...payload.response.data,
        };
      }
      if (payload && payload.key === 'fetchMyPerformance') {
        const perfObj = Object.assign({}, state);
        // console.log('perfObj ====>', payload.response.data);
        Object.keys(payload.response.data).forEach((key) => {
          // console.log('key ===>', key);
          // console.log('perfObj[key] ===>', perfObj[key]);
          perfObj[key] = {
            ...perfObj[key],
            ...payload.response.data[key],
          };
        });
        // console.log('return perfObj ===>', perfObj);
        return perfObj;
      }

      return state;
    }

    default:
      return state;
  }
}
